import React from 'react'
import BouncingArrow from '../../../assets/gifs/BouncingArrow.gif'

const Methods = () => {
  return (
    <section className='bg-brandGradient py-20 px-8 sm:px-[58px] md:px-[68px] lg:px-[90px] xl:px-32'>
        <div className='text-white text-center flex flex-col items-center'>
            <p className='headerText2 mb-4'>Where Traditional Methods Fall Short</p>
            <p className='bodyText2 mb-16'>The digital marketing of old is a story of fragmentation and inefficiency — multiple tools and channels leading to lost time and diluted strategies. It's time for a change.</p>
            <img src={BouncingArrow} alt='bouncing arrow' className='h-[60px] w-[60px]'/>
        </div>
    </section>
  )
}

export default Methods